// extracted by css-extract-rspack-plugin
export default {"messageFooter":"messageFooter-RIjE80"};